export default __webpack_public_path__ + "static/media/reportIcon.2efa7b62.svg";